<template>
    <el-date-picker v-model="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :size="size"
        :picker-options="pickerOptions" @change="dateChange">
    </el-date-picker>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: 'SelectDate',
    props: {
        size: {
            type: String,
            default: 'small'
        },
        type: {
            type: Number,
            default: 0
        },
        course_id: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            date: '',
            courseId: this.$store.state.classInfo.course_id,
            dateArr: [],
            pickerOptions: {
                disabledDate (time) {
                    return time.getTime() > Date.now()
                },
                cellClassName: (time) => {
                    for (var i = 0; i < this.dateArr.length; i++) {
                        if (time.getTime() === new Date(this.dateArr[i]).getTime()) {
                            return 'x-hd'
                        }
                    }
                },
            }
        }
    },
    computed: {
        ...mapState({
            classInfo: state => state.classInfo
        })
    },
    watch: {
        "classInfo.id" (val) {
            this.date = ''
            this.courseId = this.classInfo.course_id
            this.$emit('change-date', this.date)
            this.getDateArr()
        },
        course_id (val) {
            this.courseId = val
            console.log("课程id：", this.courseId)
            this.$emit('change-date', this.date)
            this.getDateArr()
        }
    },
    mounted () {
        this.getDateArr()
    },
    methods: {
        dateChange (val) {
            this.date = val !== null ? val : ''
            this.$emit('change-date', this.date)
        },

        // 判断当前获取哪一资源日期，0：板书，1：微课，2：批注，3：课件
        getUrl () {
            let url = ''
            switch (this.type) {
                case 0:
                    url = '/base/board/calendar'
                    break
                case 1:
                    url = '/base/wake/calendar'
                    break
                case 2:
                    url = '/base/screen/calendar'
                    break
                case 3:
                    url = '/base/file/calendar'
                    break
                case 4:
                    url = '/base/homework/calendar'
                default:
                    break
            }

            return url
        },
        // 获取有批注的板书日期
        async getDateArr () {
            const url = this.getUrl()
            const { id, course_id } = this.classInfo
            const params = {
                class_id: id,
                course_id: this.courseId,
                month: ''
            }
            const { data: res } = await this.$axios.post(url, params)
            if (res.errCode === 0) {
                const date = res.data.map(item => {
                    return item.replace(/-/g, '/')
                })
                this.dateArr = date
            }

        }
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/filterComponent/SelectDate.vue